import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=24907b4b&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=24907b4b&prod&scoped=true&lang=css"
import style1 from "./ViewUser.vue?vue&type=style&index=1&id=24907b4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24907b4b",
  null
  
)

export default component.exports